export const OPPORTUNITIES_PERIOD_FILTER = {
    min: 3,
    max: 120,
};
export const OPPORTUNITIES_AMOUNT_FILTER = {
    min: 300,
    max: 30000,
};
